import { BranchPayoutMethod } from '../../payout/models/sp-payout.models'

export interface spWalletAmount {
	walletAmount: number
	expectedAmount: number
	holdingPayouts: number
	cashBackAmount: number
	pendingAmount: number
	holdedAmount: number
	currency: {
		name: {
			en: string
			ar: string
		}
		id: number
	}
	payoutMethods: BranchPayoutMethod[]
}
export interface addSubtractPayloadModel {
	actorId: number
	currencyId: number
	amount: number
	reason: string
	actor: number
}
export interface spWalletFilter {
	paging: {
		pageNumber: number
		pageSize: number
	}
	searchText: string
	branchId: number
	startDate: string | null
	endDate: string | null
	transactionType: number | null
	isPending?: boolean
}
export interface adminWalletTotalPayload {
	countryId: number
	actor: number
}
export interface adminWalletTotalResponse {
	totalAmount: number
	totalHoldedAmount: number
	currency: {
		id: number
		name: {
			en: string
			ar: string
		}
	}
}
export interface spWalletListPayload {
	paging: {
		pageNumber: number
		pageSize: number
	}
	searchText: string
	countryId: number
	organizationId: number | null
	branchId: number | null
}
export interface clientWalletListFilter {
	paging: {
		pageNumber: number
		pageSize: number
	}
	searchText: string
	countryId: number
}
export interface clientWalletList {
	cientId: number
	clientName: string
	walletAmount: number
	walletHoldAmount: number
	currency: {
		id: number
		name: {
			en: string
			ar: string
		}
	}
}

export interface spWalletList {
	branchId: number
	providerId: number
	providerName: string
	branchName: string
	walletAmount: number
	walletHoldAmount: number

	currency: {
		id: number
		name: {
			en: string
			ar: string
		}
	}
	isPending: boolean
}
export interface spWalletList {
	id: number
	amount: number
	currency: {
		id: number
		name: {
			en: string
			ar: string
		}
	}
	transactionType: number
	operation: number
	transactionDate: string
	isHolded:boolean
	isFundedCase:boolean
	fundId: number
	title: {
		en: string
		ar: string
	}
	description: {
		en: string
		ar: string
	}
	reason: string,
	showToClient: boolean
}

export enum WalletTransactionTypeEnum {
	BookingPayment = 1,
	CancelBooking = 2,
	UnconfirmedBooking = 3,
	BookingRefund = 4,
	AddFund = 5,
	SubtractFund = 6,
	PayoutProcessing = 7,
	CancelledPayout = 8,
	PartialPayout = 9,
}
export enum WalletOperationEnum {
	Addition,
	Subtraction,
}
export enum WalletTransaction {
	Appointment = 1,
	Transaction = 2,
}
export enum SPWalletTransactionTypeEnum {
	BookingPaymentOnlinePayment = 0,
	BookingPaymentUsingWallet = 1,
	CancelBooking = 2,
	UnconfirmedBooking = 3,
	AddFund = 5,
	SubtractFund = 6,
	PayoutProcessing = 7,
	BookingRefund = 8,
}
